import { Classification } from '../../model/attr/classification';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonUtil } from '../../service/util/json.util';
import { map } from 'rxjs/operators';
import { NecUrl } from '../../model/url/url';
import { Observable } from 'rxjs';


@Injectable()
export class NecClassificationInterface {
  constructor(private http: HttpClient) {
  }

  /**
   * è·åå»é¢èä½åç±»éç½®ä¿¡æ¯
   */
  getClassification(tenantId: number): Observable<Classification[]> {
    let resId = `tenant:${tenantId}`;
    let param = new HttpParams().set('resId', resId).set('type', 'POSITION');
    return this.http.get<Classification[]>(NecUrl.SERVER_URL + '/server/classifications', {
      params: param
    }).pipe(
      map((resp: Classification[]) => {
        return JsonUtil.jsonConvert(resp, Classification);
      })
    );
  }
}
